module.exports = __webpack_public_path__ + "assets/6bc51af36756e180191fae9d0f1562b6.png";